<template>
  <BaseFilter
    :title="`${fleetModule.driver} Filter`"
    :isChips="isChips"
    @submit="$emit('apply')"
    @reset="$emit('reset')"
    @filterDialogOpen="
      getDriverOptions();
      getProjectList(selectedBranch);
    "
    :isIcon="false"
  >
    <template #form>
      <v-row no-gutters>
        <v-col cols="12" class="py-2">
          <span class="text-body-2 font-weight-bold text-capitalize">
            filter by {{ statusMapping.driverStatus }}
          </span>
          <SelectField
            id="driver_status"
            name="driver_status"
            dense
            clearable
            :label="`select ${statusMapping.driverStatus}`"
            :itemsList="statusTypes"
            itemText="display_value"
            itemValue="value"
            :value="driverFilters.status"
            class="pt-2"
            @change="driverFiltersChanged('status', $event)"
          ></SelectField>
        </v-col>
        <v-col cols="12" class="py-2">
          <span class="text-body-2 font-weight-bold text-capitalize">
            filter by {{ configurationModule.project }}
          </span>
          <SelectField
            id="project"
            name="project"
            dense
            clearable
            hide-details
            outlined
            :label="`Select ${configurationModule.project}`"
            :itemsList="projectList"
            itemText="name"
            itemValue="id"
            class="pt-2"
            :value="driverFilters.project"
            :menu-props="{ offsetY: true }"
            @change="driverFiltersChanged('project', $event)"
          ></SelectField>
        </v-col>
        <v-col cols="12" lg="12" xl="12" class="py-2">
          <span class="text-body-2 font-weight-bold text-capitalize">
            zone Assigned
          </span>
          <SelectField
            id="zone_assigned"
            name="zone_assigned"
            dense
            clearable
            hide-details
            outlined
            label="select"
            :itemsList="binaryChoice"
            itemText="label"
            itemValue="value"
            :value="driverFilters.has_zone"
            :menu-props="{ offsetY: true }"
            class="pt-2"
            @change="driverFiltersChanged('has_zone', $event)"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" lg="6" xl="6" class="pt-2">
          <span class="text-body-2 font-weight-bold text-capitalize">
            order by
          </span>
          <SelectField
            id="order_by"
            name="order_by"
            dense
            hide-details
            outlined
            clearable
            label="select value"
            :itemsList="orderBy"
            itemText="title"
            itemValue="value"
            :value="driverFilters.ordering"
            class="pt-2"
            :menu-props="{ offsetY: true }"
            @change="driverFiltersChanged('ordering', $event)"
          ></SelectField>
        </v-col>
      </v-row>
    </template>
  </BaseFilter>
</template>

<script>
import BaseFilter from "@/components/BaseComponents/BaseFilter.vue";
import { bus } from "@/main";
import { mapState } from "vuex";
import {
  fleetModule,
  statusMapping,
  configurationModule,
  orderModule,
} from "@/utils/moduleMapping";

export default {
  components: {
    BaseFilter,
  },
  props: {
    value: Boolean,
    isChips: Boolean,
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fleetModule,
      statusMapping,
      configurationModule,
      orderModule,
      orderBy: [
        { title: "Shift Start", value: "shift_start" },
        { title: "Shift Start (Descending)", value: "-shift_start" },
        { title: "Status", value: "status" },
        { title: "Status (Descending)", value: "-status" },
        // { title: "Descending", value: "descending" },
      ],
      statusTypes: [],
      binaryChoice: [
        { label: "Yes", value: true },
        {
          label: "No",
          value: false,
        },
      ],
      projectList: [],
    };
  },
  computed: {
    ...mapState("userProfile", {
      driverFilters: (state) => state.driver_filters,
    }),
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
  },
  methods: {
    getDriverOptions() {
      bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverOptions({ request_type: "filter" })
        .then((res) => {
          this.statusTypes = res?.data?.status;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    driverFiltersChanged(key, value) {
      let obj = {};
      obj[key] = value;
      this.$store.commit("userProfile/setFilters", {
        moduleKey: "driver_filters",
        payload: obj,
      });
    },
    getProjectList(id) {
      if (id) {
        this.$api.project
          .getProjectList({ limit: "all", branch: id })
          .then((res) => {
            this.projectList = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.projectList = [];
      }
    },
  },
};
</script>
